import React from 'react';

import Post from '../Shared/Post.js';

import './Lab.css';

const experiments = [
  {
    title: 'Card',
    type: 'Code',
    summary: 'Phasellus sit amet augue gravida.',
    description: 'Phasellus sit amet augue gravida, ultrices ex quis, rutrum elit. Sed lobortis ex in fermentum cursus. Praesent in porta lacus. Curabitur facilisis porttitor ante. Cras maximus diam lectus, at facilisis lectus blandit et. Maecenas facilisis, leo quis fringilla aliquet, justo risus iaculis sapien, quis mattis felis orci id nibh. Donec et ante tincidunt, laoreet tortor et, bibendum diam. Vestibulum fermentum pulvinar quam, non fermentum turpis congue eu. Donec mollis, augue sed molestie pharetra, quam nunc efficitur dui, et semper mi dui eu nunc. Sed nisi velit, facilisis semper mi in, finibus feugiat nisl. Vestibulum tempus nibh eget gravida tempus. Donec tristique lacinia sapien, ac vehicula ex elementum id. Quisque est nisl, sagittis et consectetur nec, pulvinar et sapien. Donec tristique turpis elit, a porta neque condimentum at. Vestibulum enim lectus, aliquam ut pharetra non, lobortis ac nunc',
    url: 'https://dribbble.com/shots/2917353-Card',
    images: [
      'https://cdn.dribbble.com/users/170457/screenshots/2917353/card.gif',
    ]
  }
];

class Lab extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showDetails: false,
      details: {},
      postData: []
    };
    this.showDetails = this.showDetails.bind(this)
    this.hideDetails = this.hideDetails.bind(this)
  }

  showDetails(props) {
    this.setState({
      showDetails: true,
      details: experiments[props]
    });
  }

  hideDetails() {
    this.setState({ showDetails: false });
  }

  componentDidMount(){
      this.fetchData();
  }

  fetchData(){
      this.setState({
          postData: []
      })

      fetch('http://gif-lol.com/w3/wp-json/wp/v2/posts?per_page=20')
        .then(response => response.json())
        .then(parsedJSON => parsedJSON.map(item => (
            {
                id: `${item.id}`,
                slug: `${item.slug}`
            }
        )))
        .then(postData => this.setState({
            postData
        }))
        .catch(error => console.log('parsing failed', error))
  }

  render() {
    const {postData} = this.state;

    return (
      <div className="app app-lab">
        <h1 className="app-heading color-red">Lab</h1>
        <p className="app-paragraph">You will find me here</p>

        <Post data={postData} />
      </div>
    );
  }
}

export default Lab;



// WEBPACK FOOTER //
// ./src/Pages/Lab.js